import { VaRPeriod } from "@/interfaces/raDashboard.interface"
import { NormSDist, NormSInv } from "./mathUtils"

enum VaRTypes {
  VaR = "VaR",
  CVaR = "CVaR",
  MVaR = "MVaR"
}

export function convertPeriodToTime(periodLength: number, periodUnit: VaRPeriod): number {
  if (periodUnit === VaRPeriod.Days) {
    return Math.sqrt(periodLength / 250);
  }
  return Math.sqrt(periodLength / 12);
}

export function calculateVaRType(
  totalRisk: number,
  marketValue: number,
  confidence: number,
  periodLength: number,
  periodUnit: VaRPeriod = VaRPeriod.Days,
  varType: VaRTypes = VaRTypes.VaR
): number {
  if (confidence < 0 || confidence > 100) {
    console.log(`calculateVaR: Invalid Confidence`);
    return 0;
  }
  const confidenceRatio = confidence / 100;
  const totalRiskDecimal = totalRisk / 100;
  const timeValue = convertPeriodToTime(periodLength, periodUnit);
  const confidenceInverse = NormSInv(confidenceRatio);
  if (confidenceInverse == 0) {
    return 0;
  }
  let confidenceModifier = confidenceInverse;
  if (varType == VaRTypes.CVaR) {
    confidenceModifier = NormSDist(confidenceInverse, false) / (1 - confidenceRatio);
  }
  const returnValue = totalRiskDecimal * marketValue * timeValue * confidenceModifier;
  return returnValue;
}

export function calculateVaR(
  totalRisk: number,
  marketValue: number,
  confidence: number,
  periodLength: number,
  periodUnit: VaRPeriod
): number {
  return calculateVaRType(totalRisk, marketValue, confidence, periodLength, periodUnit, VaRTypes.VaR);
}

export function calculateCVaR(
  totalRisk: number,
  marketValue: number,
  confidence: number,
  periodLength: number,
  periodUnit: VaRPeriod
): number {
  return calculateVaRType(totalRisk, marketValue, confidence, periodLength, periodUnit, VaRTypes.CVaR);
}

